import React from 'react';
import { useReveal } from '../../hooks/useReveal';
import '../../styles/Mission.css';

interface Pillar {
  num: string;
  title: string;
  body: string;
  note?: string;
}

interface MissionProps {
  chapter?: string;
  label?: string;
  pullQuote?: string;
  pillars?: Pillar[];
}

const DEFAULT_PILLARS: Pillar[] = [
  {
    num: 'I',
    title: 'Resgate e tratamento',
    body:
      'Cada animal passa por avaliação veterinária, esterilização e quarentena antes de conhecer qualquer adotante.',
    note: '— sem atalhos.',
  },
  {
    num: 'II',
    title: 'Adoção responsável',
    body:
      'Entrevistamos, visitamos casas, acompanhamos nos primeiros meses. Uma adoção é um compromisso para a vida.',
    note: '— para a vida, mesmo.',
  },
  {
    num: 'III',
    title: 'Comunidade',
    body:
      'Voluntários, famílias de acolhimento e doadores: tudo o que fazemos depende de quem está connosco.',
    note: '— talvez tu.',
  },
];

const Mission: React.FC<MissionProps> = ({
  chapter = 'Cap. I · A nossa missão',
  label = 'Notas de um abrigo pequeno, paciente e teimoso — em Silvalde, desde 2019.',
  pullQuote = '"Nenhum animal sai antes de estar pronto.\nNenhuma família é escolhida à pressa."',
  pillars = DEFAULT_PILLARS,
}) => {
  const quoteLines = pullQuote.split('\n');
  const { ref, revealed } = useReveal<HTMLElement>();
  return (
    <section
      ref={ref}
      className={`mission psl-reveal${revealed ? ' is-in-view' : ''}`}
    >
      <div>
        <div className="mission__chapter">{chapter}</div>
        <p className="mission__label">{label}</p>
      </div>
      <div>
        <h2 className="mission__head">
          Acolher com <em>dignidade</em>.<br />
          Entregar com <em>cuidado</em>.<br />
          Nunca apressar.
        </h2>
      </div>
      <div className="mission__pull">
        {quoteLines.map((line, i) => (
          <React.Fragment key={i}>
            {line}
            {i < quoteLines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>

      <div className="mission__pillars">
        {pillars.map((p) => (
          <div className="pillar" key={p.num}>
            <div className="pillar__num">{p.num}</div>
            <h3 className="pillar__title">{p.title}</h3>
            <p className="pillar__body">{p.body}</p>
            {p.note && <span className="pillar__note">{p.note}</span>}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Mission;
